import { useAppSelector } from '@redux/hooks';
import { selectRegion } from '@redux/slices/header';
import { useGetProductAllAvailabilityQuery } from '../../module/services/getProductAvailabilityInTheStoresData/getProductAvailabilityInTheStoresData';
import { RowAvailability } from '@features/productAvailabilityInTheStores';
import { ButtonSize, ButtonThemes, SkeletonLoading } from '@app/shared';
import { ButtonFastOrder, TypeTemplateFastOrder } from '@features/fastOrder';
import classNames from 'classnames';
import { DeliveryTypeProduct } from '@entities/Delivery';

export const AvailabilityCatalogProduct = ({ productRN, part, productUrl, className }) => {
  const { REGION: regionId } = useAppSelector(selectRegion);
  const { data, isLoading } = useGetProductAllAvailabilityQuery({ productRN, part, regionId: +regionId });
  const hasNonTodayDeliveryStores = data?.pickUpAllShops?.some(shop => shop?.type?.includes(DeliveryTypeProduct.NotToday));
  if (isLoading) {
    return <SkeletonLoading width={'100%'} height={'21px'} />;
  }

  return (
    <AvailabilityCatalogProduct.Wrapper className={className}>
      <RowAvailability.Row
        availabilityNow={data.overall.availabilityNow}
        availabilityLater={data.overall.availabilityLater}
        productUrl={productUrl}
        isCatalog={true}
        hasNonTodayDeliveryStores={hasNonTodayDeliveryStores}
      />
    </AvailabilityCatalogProduct.Wrapper>
  );
};

AvailabilityCatalogProduct.Wrapper = function ({ children, className }) {
  return <div className={classNames(className)}>{children}</div>;
};

AvailabilityCatalogProduct.ButtonFastOrder = function ({
  productRN,
  part,
  mainTitle,
  subTitle,
  productId,
  price,
  count,
  allQuantity,
  className,
}) {
  const { REGION: regionId } = useAppSelector(selectRegion);
  const { data, isLoading } = useGetProductAllAvailabilityQuery({ productRN, part, regionId: +regionId });

  const isOffers = !!data?.pickUpAllShops?.length;

  if (isLoading) {
    return <SkeletonLoading width={'100%'} height={'40px'} />;
  }

  return (
    <ButtonFastOrder
      className={className}
      themes={ButtonThemes.Secondary}
      size={ButtonSize.S}
      template={isOffers ? TypeTemplateFastOrder.pickUpStore : TypeTemplateFastOrder.orderOneClick}
      productData={{
        productName: mainTitle,
        productSpecName: subTitle,
        productId,
        productRn: productRN,
        part,
        price,
        quantity: count,
        allQuantity,
      }}
    >
      {isOffers ? 'Забрать из магазина' : 'Быстрый заказ'}
    </ButtonFastOrder>
  );
};
